/* fc-pp-info-ring.js (2026-10-12 speed pass): the liquid-glass travelling
   selection ring for the option chips and gallery thumbnails. Former inline
   script of sections/fc-pp-info.liquid, unchanged; loaded deferred right
   BEFORE fc-pp-info.js so its document-level change listener is registered
   before fc-pp-info.js may dispatch its init-time synthetic change (same
   order as when this ran inline). */
  /* ── Liquid-glass traveling selection ring (2026-08-22) ────────────────
     Same gel morph as the collection variant ring. Selection here is
     radio-input driven (:has(input:checked)), so: capture the previously
     checked chip on pointer-down/click (capture phase), then animate on
     the input's change event. First interaction animates too (the fresh
     ring is seated at the previous chip before its first flight). */
  (function () {
    'use strict';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function chipOf(wrap) { return wrap ? wrap.querySelector('.fc-pp__chip') : null; }
    function checkedWrap(group) {
      var input = group.querySelector('.fc-pp__chip-wrap input:checked');
      return input ? input.closest('.fc-pp__chip-wrap') : null;
    }
    function placeRing(ring, group, chip, animate) {
      var rg = group.getBoundingClientRect();
      var rb = chip.getBoundingClientRect();
      var to = { left: rb.left - rg.left, top: rb.top - rg.top, w: rb.width, h: rb.height };
      var hadPos = ring.style.width !== '';
      var from = hadPos ? {
        left: parseFloat(ring.style.left), top: parseFloat(ring.style.top),
        w: parseFloat(ring.style.width), h: parseFloat(ring.style.height)
      } : null;
      ring.style.left = to.left + 'px';
      ring.style.top = to.top + 'px';
      ring.style.width = to.w + 'px';
      ring.style.height = to.h + 'px';
      if (!animate || !from || reduce || typeof ring.animate !== 'function') return;
      var dx = to.left - from.left;
      var sameLine = Math.abs(to.top - from.top) < 4;
      var midW = sameLine ? Math.min(Math.abs(dx) * 0.6 + to.w, to.w * 2.4) : to.w * 1.2;
      var midL = sameLine ? (dx >= 0 ? from.left + dx * 0.25 : from.left + dx * 0.75) : from.left + dx * 0.5;
      var midH = to.h * 0.88;
      var midT = (from.top + to.top) / 2 + (to.h - midH) / 2;
      var squashW = to.w * 0.92, squashH = to.h * 1.06;
      var reboundW = to.w * 1.04, reboundH = to.h * 0.97;
      if (ring.__anim) ring.__anim.cancel();
      ring.__anim = ring.animate([
        { left: from.left + 'px', top: from.top + 'px', width: from.w + 'px', height: from.h + 'px', offset: 0 },
        { left: midL + 'px', top: midT + 'px', width: midW + 'px', height: midH + 'px', offset: 0.38 },
        { left: (to.left + (to.w - squashW) / 2) + 'px', top: (to.top - (squashH - to.h) / 2) + 'px', width: squashW + 'px', height: squashH + 'px', offset: 0.68 },
        { left: (to.left + (to.w - reboundW) / 2) + 'px', top: (to.top + (to.h - reboundH) / 2) + 'px', width: reboundW + 'px', height: reboundH + 'px', offset: 0.85 },
        { left: to.left + 'px', top: to.top + 'px', width: to.w + 'px', height: to.h + 'px', offset: 1 }
      ], { duration: 650, easing: 'cubic-bezier(0.3, 0.75, 0.35, 1)' });
    }

    /* capture the outgoing selection BEFORE the radio flips — must be
       pointerdown: radios update :checked before the click event even
       fires (pre-click activation), so a click-capture snapshot already
       sees the NEW state. */
    document.addEventListener('pointerdown', function (e) {
      var wrap = e.target.closest('.fc-pp__chip-wrap');
      if (!wrap) return;
      var group = wrap.closest('.fc-pp__chips');
      if (group) group.__prevWrap = checkedWrap(group);
    }, true);

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('.fc-pp__chip-wrap input')) return;
      var group = input.closest('.fc-pp__chips');
      var wrap = input.closest('.fc-pp__chip-wrap');
      var chip = chipOf(wrap);
      if (!group || !chip) return;
      var ring = group.querySelector(':scope > .fc-pp__sel-ring');
      if (!ring) {
        ring = document.createElement('span');
        ring.className = 'fc-pp__sel-ring';
        ring.setAttribute('aria-hidden', 'true');
        group.appendChild(ring);
        group.classList.add('has-sel-ring');
        var prevChip = chipOf(group.__prevWrap);
        if (prevChip && prevChip !== chip) placeRing(ring, group, prevChip, false);
      }
      placeRing(ring, group, chip, true);
    });

    var rafId = null;
    window.addEventListener('resize', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        document.querySelectorAll('.fc-pp__chips.has-sel-ring').forEach(function (group) {
          var ring = group.querySelector(':scope > .fc-pp__sel-ring');
          var chip = chipOf(checkedWrap(group));
          if (ring && chip) placeRing(ring, group, chip, false);
        });
        document.querySelectorAll('.fc-pp__thumbs.has-sel-ring').forEach(function (rail) {
          if (rail.__reseat) rail.__reseat();
        });
      });
    });

    /* ── Gallery thumbnail ring: same gel morph, scroll-aware ──────────
       offsetLeft/offsetTop are content-relative, so the ring rides along
       when the snap rail scrolls. A MutationObserver drives it: clicks,
       gallery swipes and color-set filter re-picks all glide. */
    document.querySelectorAll('.fc-pp__thumbs').forEach(function (rail) {
      var ring = null, anim = null, pending = null;
      function activeThumb() { return rail.querySelector('.fc-pp__thumb.is-active'); }
      function seat(animate) {
        var t = activeThumb();
        if (!t || !t.offsetWidth) return;
        if (!ring) {
          ring = document.createElement('span');
          ring.className = 'fc-pp__thumb-ring';
          ring.setAttribute('aria-hidden', 'true');
          rail.appendChild(ring);
          rail.classList.add('has-sel-ring');
          animate = false;
        }
        var to = { left: t.offsetLeft, top: t.offsetTop, w: t.offsetWidth, h: t.offsetHeight };
        var hadPos = ring.style.width !== '';
        var from = hadPos ? {
          left: parseFloat(ring.style.left), top: parseFloat(ring.style.top),
          w: parseFloat(ring.style.width), h: parseFloat(ring.style.height)
        } : null;
        ring.style.left = to.left + 'px';
        ring.style.top = to.top + 'px';
        ring.style.width = to.w + 'px';
        ring.style.height = to.h + 'px';
        if (!animate || !from || reduce || typeof ring.animate !== 'function') return;
        if (from.left === to.left && from.top === to.top) return;
        var dx = to.left - from.left;
        var midW = Math.min(Math.abs(dx) * 0.6 + to.w, to.w * 2);
        var midL = dx >= 0 ? from.left + dx * 0.25 : from.left + dx * 0.75;
        var midH = to.h * 0.9;
        var midT = (from.top + to.top) / 2 + (to.h - midH) / 2;
        var squashW = to.w * 0.94, squashH = to.h * 1.05;
        var reboundW = to.w * 1.03, reboundH = to.h * 0.98;
        if (anim) anim.cancel();
        anim = ring.animate([
          { left: from.left + 'px', top: from.top + 'px', width: from.w + 'px', height: from.h + 'px', offset: 0 },
          { left: midL + 'px', top: midT + 'px', width: midW + 'px', height: midH + 'px', offset: 0.38 },
          { left: (to.left + (to.w - squashW) / 2) + 'px', top: (to.top - (squashH - to.h) / 2) + 'px', width: squashW + 'px', height: squashH + 'px', offset: 0.68 },
          { left: (to.left + (to.w - reboundW) / 2) + 'px', top: (to.top + (to.h - reboundH) / 2) + 'px', width: reboundW + 'px', height: reboundH + 'px', offset: 0.85 },
          { left: to.left + 'px', top: to.top + 'px', width: to.w + 'px', height: to.h + 'px', offset: 1 }
        ], { duration: 650, easing: 'cubic-bezier(0.3, 0.75, 0.35, 1)' });
      }
      rail.__reseat = function () { seat(false); };
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = requestAnimationFrame(function () { pending = null; seat(true); });
      });
      mo.observe(rail, { attributes: true, subtree: true, attributeFilter: ['class'] });
      seat(false);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { seat(false); });
    });
  })();
